export enum CaseCodesEnum{
    Icd="1",
    Cpt="2",
    Preoperatives="3",
    Procedures="4",
    MedicalDevices="5",
    Vendors="6"
}